module.exports = __webpack_public_path__ + "static/media/zero-and-the-slicks.c9f33a3b.jpg";